type TypeaheadProps = {
  keyword: string;
  content: string;
  className?: string;
};

const Typeahead = (props: TypeaheadProps) => {
  const { keyword, content, className } = props;
  const keywordLowerCase: string = keyword.toLowerCase();
  const contentLowerCase: string = content.toLowerCase();
  const index = contentLowerCase.indexOf(keywordLowerCase);
  if (index !== -1 && keyword.length > 0) {
    return (
      <span className={className}>
        {content.substring(0, index)}
        <span className="bg-bg-primary-min">
          {content.substring(index, keyword.length + index)}
        </span>
        {content.substring(keyword.length + index, content.length)}
      </span>
    );
  }
  return <span className={className}>{content}</span>;
};

export default Typeahead;
